<template>
  <div class="app-forgot-password-msisdn">
    <slot name="infotext">
      Sie benötigen ein Passwort zu Ihrem Mitgliederbereich oder haben Ihr Passwort vergessen? Geben Sie bitte im unten
      stehenden Feld Ihre Rufnummer ein und klicken Sie auf Weiter. Anschließend können Sie entscheiden, ob Sie einen Link an
      Ihre hinterlegte E-Mail-Adresse oder eine SMS an ihre Rufnummer erhalten möchten, um ein neues Passwort zu vergeben.
    </slot>
    <form>
      <div class="inputs-container">
        <div class="input-field">
          <label class="text-base-medium" for="msisdn"><slot name="label">Ihre mobil Rufnummer</slot></label>
          <input
            id="msisdn"
            name="msisdn"
            type="text"
            class="input"
            :class="{ error: !isValid('inputMsisdn') && $v.inputMsisdn.$dirty }"
            required
            placeholder="Rufnummer hier eingeben"
            v-model.trim="inputMsisdn"
            @input="$v.inputMsisdn.$touch"
          />
          <span v-if="!isValid('inputMsisdn') && $v.inputMsisdn.$dirty" class="text-sm text-error">
            Bitte gib eine gültige Rufnummer ein.
          </span>
        </div>
      </div>
      <slot name="txtBeforeButton"></slot>
      <Stepper :show-prev="false" @next="save()">
        <template #btnPrev><slot name="btnPrev"></slot></template>
        <template #btnNext><slot name="buttonLabel">weiter</slot></template>
      </Stepper>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import isValid from '../../../../../mixins/isValid'
import { mapMutations, mapGetters } from 'vuex'
import preFilledInput from '../../../../../mixins/preFilledInput'
import Stepper from '@/components-v2/generic/Stepper.vue'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export default {
  name: 'ForgotPasswordMsisdn',
  components: {
    Stepper
  },
  methods: {
    ...mapMutations('forgotPassword', ['captureMsisdn']),
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.captureMsisdn(this.inputMsisdn)
    }
  },
  computed: {
    ...mapGetters('forgotPassword', ['msisdn'])
  },
  mixins: [validationMixin, isValid, preFilledInput('inputMsisdn', 'msisdn')],
  validations() {
    return {
      inputMsisdn: {
        required,
        isPhoneNumber
      }
    }
  }
}
</script>
